import React from 'react';

import {
	useIsDigimarcCorrect,
	useIsQrCodeRecognized,
} from '../../store/scanSession/selectors';
import VerificationCounterfeit from '../../components/VerificationCounterfeit';
import VerificationSuccess from '../../components/VerificationSuccess';
import VerificationTampering from '../../components/VerificationTampering';

function Results() {
	const isQrRecognized = useIsQrCodeRecognized();
	const isDigimarcCorrect = useIsDigimarcCorrect();

	if (isQrRecognized && isDigimarcCorrect) {
		return <VerificationSuccess />; // only show success
	} else if (isQrRecognized) {
		return <VerificationTampering />;
	} else {
		return <VerificationCounterfeit />;
	}
}

export default Results;
